import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewRaza = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'raza',
        name: 'Raza',
        component: ViewRaza,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
